module.exports = {
  "id": "apron",
  "title": "apron",
  "image": "provision/parts/apron/apron.png",
  "info": [
    {
      "text": "It's an apron! <br> <br> Try it on with the pin to piece <i class='icon icon-pushpin blue'></i> sticker",
      "image": "provision/parts/apron/apron.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/apron/apron.png"
} ;